import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import { ROUTES } from './enum/routes';
import { LEGACY_SERVICE_REDIRECTS } from './data/services';
import { isAdsHost } from './utils/host';
import HomePage from './Pages/Home';
import QuotePage from './Pages/Quote';
import AdLandingPage from './Pages/AdLanding';
import ServiceAreasPage from './Pages/ServiceAreas';
import PrivacyPage from './Pages/Privacy';
import TermsPage from './Pages/Terms';
import ServicePage from './Pages/Service';
import ServicesPage from './Pages/Services';
import LocationPage from './Pages/Location';
import ServiceCityPage from './Pages/ServiceCity';

function AdsApp() {
  return (
    <Routes>
      <Route path="/" element={<AdLandingPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function MainApp() {
  return (
    <Routes>
      {/* <Route path={ROUTES.GET_ESTIMATE} element={<AdLandingPage />} /> */}
      <Route element={<Layout />}>
        <Route path={ROUTES.HOME} element={<HomePage />} />
        <Route path={ROUTES.QUOTE} element={<QuotePage />} />
        <Route path={ROUTES.SERVICE_AREAS} element={<ServiceAreasPage />} />
        <Route path={ROUTES.PRIVACY} element={<PrivacyPage />} />
        <Route path={ROUTES.TERMS} element={<TermsPage />} />
        <Route path={ROUTES.SERVICES} element={<ServicesPage />} />
        <Route path="/services/:serviceSlug/:citySlug" element={<ServiceCityPage />} />
        <Route path="/services/:serviceSlug" element={<ServicePage />} />
        <Route path="/locations/:citySlug" element={<LocationPage />} />
        {Object.entries(LEGACY_SERVICE_REDIRECTS).map(([from, to]) => (
          <Route key={from} path={from} element={<Navigate to={to} replace />} />
        ))}
        <Route path="*" element={<HomePage />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  const adsOnly = isAdsHost();

  return <div className="App min-h-screen">{adsOnly ? <AdsApp /> : <MainApp />}</div>;
}
